module.exports = __webpack_public_path__ + "videos/5.e2ee3d1.mp4";